import { style } from '@vanilla-extract/css'

import { getRgba } from '~/styles/mixins/color.css'
import { getFontSize } from '~/styles/mixins/font.css'
import { getMarginListItems, getPaddingListItem } from '~/styles/mixins/list.css'
import { getMediaQuery } from '~/styles/mixins/mediaQuery.css'
import { getTransition } from '~/styles/mixins/transition.css'
import { gradationPrimary, gradationPrimaryDark } from '~/styles/variables/color.css'
import { cssVariables } from '~/styles/variables/cssVariables.css'

export const layoutHeader__signIn = style({})

export const layoutHeader = style({
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: cssVariables.zIndex.header.base,
  width: '100%',
  transition: getTransition([
    {
      property: 'padding',
    },
  ]),

  '@media': {
    [getMediaQuery('md')]: {
      selectors: {
        [`&${layoutHeader__signIn}`]: {
          paddingLeft: 230,
        },
      },
    },
  },
})

export const layoutHeader_wrapper = style({
  backgroundColor: cssVariables.color.white.hex,
  boxShadow: `0 4px 4px ${getRgba(cssVariables.color.black.rgb, 0.04)}`,
})

export const layoutHeader_container = style({
  display: 'flex',
  height: 56,
  transition: getTransition([
    {
      property: 'height',
    },
  ]),

  '@media': {
    [getMediaQuery('sm')]: {
      height: 64,
    },
  },
})

export const layoutHeaderLogo = style({
  flexShrink: 0,
  marginRight: 16,

  '@media': {
    [getMediaQuery('md')]: {
      selectors: {
        [`${layoutHeader}${layoutHeader__signIn} &`]: {
          display: 'none',
        },
      },
    },
  },
})

export const layoutHeaderLogo_link = style({
  selectors: {
    '&:not(:root)': {
      display: 'flex',
      alignItems: 'center',
      height: '100%',
    },
  },

  '@media': {
    [getMediaQuery('hover')]: {
      selectors: {
        '&:not(:root):hover': {
          opacity: cssVariables.opacity.hover,
        },
      },
    },
  },
})

export const layoutHeaderLogo_image = style({
  width: 120,
  height: 'auto',

  '@media': {
    [getMediaQuery('sm')]: {
      width: 164,
    },
  },
})

export const layoutHeader_contents = style({
  display: 'flex',
  flexGrow: 1,
})

export const layoutHeaderMenu = style({
  marginLeft: 'auto',
})

export const layoutHeaderMenu_container = style({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
})

export const layoutHeaderMenu_items = style({
  display: 'flex',
  alignItems: 'center',
  margin: getMarginListItems(8),

  '@media': {
    [getMediaQuery('sm')]: {
      margin: getMarginListItems(16),
    },
  },
})

export const layoutHeaderMenu_item = style({
  padding: getPaddingListItem(8),

  '@media': {
    [getMediaQuery('sm')]: {
      padding: getPaddingListItem(16),
    },
  },
})

export const layoutHeaderSignInMenu = style({
  marginLeft: 'auto',
  display: 'flex',
})

export const layoutHeaderMenuButton = style({
  flexShrink: 0,
  height: '100%',
  position: 'relative',
  zIndex: cssVariables.zIndex.header.menuButton,

  '@media': {
    [getMediaQuery('md')]: {
      display: 'none',
    },
  },
})

export const layoutHeaderMenuButton_button__active = style({})

export const layoutHeaderMenuButton_button = style({
  selectors: {
    '&:not(:root)': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      height: '100%',
      minWidth: 64,
      border: 'none',
      borderRadius: 0,
      padding: 0,
      backgroundColor: 'transparent',
    },
  },
})

export const layoutHeaderMenuButton_container = style({
  display: 'block',
})

export const layoutHeaderMenuButton_icons = style({
  display: 'block',
  margin: 0,
  height: 16,
  width: 24,
  position: 'relative',
})

export const layoutHeaderMenuButton_icon = style({
  display: 'block',
  width: '100%',
  height: 2,
  position: 'absolute',
  left: 0,
  transition: getTransition([
    {
      property: 'opacity',
    },
    {
      property: 'transform',
    },
    {
      property: 'top',
    },
    {
      property: 'bottom',
    },
  ]),

  selectors: {
    '&:before': {
      content: '',
      position: 'absolute',
      zIndex: 2,
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      backgroundColor: cssVariables.color.corduroy.hex,
      transition: getTransition([
        {
          property: 'opacity',
        },
      ]),
    },

    '&:after': {
      content: '',
      position: 'absolute',
      zIndex: 1,
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      background: `linear-gradient(90deg, ${gradationPrimary})`,
    },

    [`${layoutHeaderMenuButton_icons} > &:nth-of-type(1)`]: {
      top: 0,
    },

    [`${layoutHeaderMenuButton_icons} > &:nth-of-type(2)`]: {
      top: '50%',
      marginTop: -1,
    },

    [`${layoutHeaderMenuButton_icons} > &:nth-of-type(3)`]: {
      bottom: 0,
    },

    [`${layoutHeaderMenuButton_button}${layoutHeaderMenuButton_button__active} ${layoutHeaderMenuButton_icons} > &:nth-of-type(1)`]:
      {
        top: 6,
        transform: 'rotate(-45deg)',
      },

    [`${layoutHeaderMenuButton_button}${layoutHeaderMenuButton_button__active} ${layoutHeaderMenuButton_icons} > &:nth-of-type(2)`]:
      {
        opacity: 0,
      },

    [`${layoutHeaderMenuButton_button}${layoutHeaderMenuButton_button__active} ${layoutHeaderMenuButton_icons} > &:nth-of-type(3)`]:
      {
        bottom: 8,
        transform: 'rotate(45deg)',
      },
  },

  '@media': {
    [getMediaQuery('hover')]: {
      selectors: {
        [`${layoutHeaderMenuButton_button}:hover &:before`]: {
          opacity: 0,
        },
      },
    },
  },
})

export const layoutHeaderSignInOuterMenu = style({
  display: 'block',
  height: '100%',
  overflowY: 'auto',
  overscrollBehavior: 'contain',
  position: 'fixed',
  right: 0,
  top: 0,
  width: 300,
  backgroundColor: cssVariables.color.outerSpace.hex,
  zIndex: cssVariables.zIndex.header.signInMenu,

  '@media': {
    [getMediaQuery('sm')]: {
      width: 320,
    },

    [getMediaQuery('md')]: {
      display: 'none',
    },
  },
})

export const layoutHeaderSignInOuterMenu_container = style({
  minHeight: 'calc(100% + 1px)',
  paddingBottom: 80,
})

export const layoutHeaderSignInOuterMenuUser = style({
  backgroundColor: cssVariables.color.concrete.hex,
  padding: '56px 24px 24px',

  '@media': {
    [getMediaQuery('sm')]: {
      paddingTop: 64,
    },
  },
})

export const layoutHeaderSignInOuterMenuUser_container = style({
  display: 'flex',
  alignItems: 'center',
})

export const layoutHeaderSignInOuterMenuUser_icon = style({
  flexShrink: 0,
  marginRight: 16,
})

export const layoutHeaderSignInOuterMenuUser_name = style({
  display: 'block',
  flexGrow: 1,
  fontWeight: cssVariables.font.weight.bold,
  fontSize: getFontSize(16),
  color: cssVariables.color.corduroy.hex,
})

export const layoutHeaderSignInOuterMenuNavigation = style({})

export const layoutHeaderSignInOuterMenuNavigation_navigation = style({})

export const layoutHeaderSignInOuterMenuNavigationMain = style({
  backgroundColor: cssVariables.color.capeCod.hex,
})

export const layoutHeaderSignInOuterMenuNavigationMain_items = style({})

export const layoutHeaderSignInOuterMenuNavigationMain_item = style({})

export const layoutHeaderSignInOuterMenuNavigationMain_container = style({})

export const layoutHeaderSignInOuterMenuNavigationMainLink = style({
  selectors: {
    '&:not(:root)': {
      display: 'flex',
      padding: '16px 24px',
      textDecoration: 'none',
      color: cssVariables.color.white.hex,
      fontSize: getFontSize(14),
      fontWeight: cssVariables.font.weight.bold,
    },
  },

  '@media': {
    [getMediaQuery('hover')]: {
      selectors: {
        '&:not(:root):hover': {
          backgroundColor: cssVariables.color.hintOfGreen.hex,
        },
      },
    },
  },
})

export const layoutHeaderSignInOuterMenuNavigationMainLink_icon = style({
  flexShrink: 0,
  marginRight: 16,

  '@media': {
    [getMediaQuery('hover')]: {
      selectors: {
        [`${layoutHeaderSignInOuterMenuNavigationMainLink}:hover &`]: {
          background: `linear-gradient(90deg, ${gradationPrimaryDark})`,
        },
      },
    },
  },
})

export const layoutHeaderSignInOuterMenuNavigationMainLink_text = style({
  display: 'inline-block',

  '@media': {
    [getMediaQuery('hover')]: {
      selectors: {
        [`${layoutHeaderSignInOuterMenuNavigationMainLink}:hover &`]: {
          background: `linear-gradient(90deg, ${gradationPrimaryDark})`,
          WebkitBackgroundClip: 'text',
          backgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        },
      },
    },
  },
})

export const layoutHeaderSignInOuterMenuNavigationSub = style({
  marginTop: 8,
})

export const layoutHeaderSignInOuterMenuNavigationSub_items = style({})

export const layoutHeaderSignInOuterMenuNavigationSub_item = style({})

export const layoutHeaderSignInOuterMenuNavigationSub_container = style({})

export const layoutHeaderSignInOuterMenuNavigationSubLink = style({
  selectors: {
    '&:not(:root)': {
      display: 'block',
      padding: '12px 24px',
      textDecoration: 'none',
      color: cssVariables.color.white.hex,
      fontSize: getFontSize(12),
      position: 'relative',
      width: '100%',
      textAlign: 'left',
      borderRadius: 0,
      border: 'none',
      backgroundColor: 'transparent',
      transition: getTransition([
        {
          property: 'color',
        },
      ]),
    },

    '&:after': {
      content: '',
      position: 'absolute',
      width: 'calc(100% - 24px)',
      height: 1,
      bottom: 0,
      right: 0,
      backgroundColor: cssVariables.color.corduroy.hex,
    },
  },

  '@media': {
    [getMediaQuery('hover')]: {
      selectors: {
        '&:not(:root):hover': {
          color: cssVariables.color.shamrockDark.hex,
        },
      },
    },
  },
})

export const layoutHeaderSignInOuterMenuNavigationSubLink_text = style({
  display: 'block',
})

export const layoutHeaderPopupMenu = style({
  display: 'none',
  position: 'relative',

  '@media': {
    [getMediaQuery('md')]: {
      display: 'block',
    },
  },
})

export const layoutHeaderPopupMenuButton = style({
  selectors: {
    '&:not(:root)': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      width: 180,
      height: '100%',
      padding: 0,
      borderRadius: 0,
      border: 'none',
      backgroundColor: 'transparent',
      textAlign: 'left',
    },
  },
})

export const layoutHeaderPopupMenuButton_user = style({
  flexShrink: 0,
  marginRight: 8,
})

export const layoutHeaderPopupMenuButton_name = style({
  display: '-webkit-box',
  overflow: 'hidden',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  fontSize: getFontSize(12),
  fontWeight: cssVariables.font.weight.bold,
})

export const layoutHeaderPopupMenuButton_icon = style({
  flexShrink: 0,
  marginLeft: 8,

  '@media': {
    [getMediaQuery('hover')]: {
      selectors: {
        [`${layoutHeaderPopupMenuButton}:hover &:before`]: {
          background: `linear-gradient(90deg, ${gradationPrimaryDark})`,
        },
      },
    },
  },
})

export const layoutHeaderPopupMenu_wrapper = style({
  display: 'block',
  position: 'absolute',
  top: '100%',
  right: 0,
  zIndex: cssVariables.zIndex.header.popupMenu,
})

export const layoutHeaderPopupMenu_container = style({
  display: 'block',
  width: 240,
  border: `1px solid ${cssVariables.color.iron.hex}`,
  backgroundColor: getRgba(cssVariables.color.white.rgb, 0.9),
  borderRadius: '0 0 4px 4px',
  padding: '16px 0',
})

export const layoutHeaderPopupMenuMain = style({})

export const layoutHeaderPopupMenuMain_items = style({})

export const layoutHeaderPopupMenuMain_item = style({})

export const layoutHeaderPopupMenuMain_container = style({})

export const layoutHeaderPopupMenuMainLink = style({
  selectors: {
    '&:not(:root)': {
      display: 'block',
      padding: '12px 16px',
      textDecoration: 'none',
      color: cssVariables.color.corduroy.hex,
      fontSize: getFontSize(12),
      width: '100%',
      textAlign: 'left',
      borderRadius: 0,
      border: 'none',
      backgroundColor: 'transparent',
      transition: getTransition([
        {
          property: 'color',
        },
      ]),
    },
  },

  '@media': {
    [getMediaQuery('hover')]: {
      selectors: {
        '&:not(:root):hover': {
          color: cssVariables.color.shamrockDark.hex,
        },
      },
    },
  },
})

export const layoutHeaderPopupMenuMainLink_text = style({})

export const layoutHeaderOverlay = style({
  display: 'block',
  width: '100%',
  height: '100%',
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: cssVariables.zIndex.header.signInMenuOverlay,
  overscrollBehavior: 'contain',
  overflowY: 'auto',
  backdropFilter: 'blur(8px)',
  backgroundColor: getRgba(cssVariables.color.black.rgb, 0.2),

  '@media': {
    [getMediaQuery('md')]: {
      display: 'none',
    },
  },
})

export const layoutHeaderOverlay_container = style({
  minHeight: 'calc(100% + 1px)',
})

export const layoutHeaderAuthed = style({
  paddingTop: 8,
  position: 'relative',
  zIndex: cssVariables.zIndex.header.authed,
})

export const layoutHeaderAuthed_wrapper = style({
  padding: 8,
  backgroundColor: cssVariables.color.shamrockDark.hex,
  boxShadow: `0 4px 4px ${getRgba(cssVariables.color.black.rgb, 0.04)}`,
  borderRadius: 4,
  minHeight: 56,
  display: 'flex',
  alignItems: 'center',

  '@media': {
    [getMediaQuery('sm')]: {
      padding: '8px 16px',
    },
  },
})

export const layoutHeaderAuthed_container = style({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
})

export const layoutHeaderAuthed_paragraph = style({
  flexGrow: 1,
  fontSize: getFontSize(12),
  color: cssVariables.color.white.hex,

  '@media': {
    [getMediaQuery('lg')]: {
      fontSize: getFontSize(14),
    },
  },
})

export const layoutHeaderAuthedReSend = style({
  flexShrink: 0,
  marginLeft: 16,
})

export const layoutHeaderAuthedReSend_form = style({})

export const layoutHeaderAuthedReSend_button = style({})
